module.exports = __webpack_public_path__ + "img/project9_15.png.fe9ea31e.webp";